import { apiFetch } from '@/utils/fetchWrapper';

type MetaVersionResponse = {
  version: string;
};

export const metaService = {
  async getVersion(): Promise<MetaVersionResponse> {
    return apiFetch<MetaVersionResponse>('/meta/version/');
  },
};

